import { get } from 'utils/request';
import { getRefreshDataHeader } from '../utils/getRefreshDataHeader';
import { mockLegendResponse } from '../mocks/legend';

export interface Layers {
  name: string;
  year: number;
  key: number;
  subCategories: string[];
  enabled: boolean;
  endPoint: string;
}

export interface Categories {
  name: string;
  layers: Layers[];
}

export interface LegendResponse {
  externalSources: [];
  layerCategories: Categories[];
}

const useLegendActions = () => {
  const getLegend = async (
    refreshLegendToolbar: boolean = false,
    options: { layerKeys?: string[] } = {},
  ): Promise<LegendResponse> => {
    const useMockLegend =
      process.env.REACT_APP_USE_MOCK_LEGEND === 'true' ||
      localStorage.getItem('useMockLegend') === 'true';

    if (useMockLegend) {
      return mockLegendResponse;
    }
    const { layerKeys } = options;

    const headers = getRefreshDataHeader(refreshLegendToolbar);
    const params: Record<string, string> = {};

    if (layerKeys && layerKeys.length > 0) {
      params.layerKeys = layerKeys.join(',');
    }

    if (refreshLegendToolbar) {
      params._ts = `${Date.now()}`;
    }

    const config = {
      ...headers,
      ...(Object.keys(params).length > 0 && { params }),
    };

    try {
      const response = await get<LegendResponse>('visualiser/legend', config);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch legend data:', error);
      throw error;
    }
  };

  return {
    getLegend,
  };
};

export { useLegendActions };
